function showSearchPanel(){
    $(".header-search").addClass("opened");
    $(".ya-site-form__input-text",".header-search")
        .val("")
        .focus();
}

function closeSearchPanel(){
    $(".header-search").removeClass("opened");
}